import BigNumber from 'bignumber.js';
import {
  MARKET_MONEYLINES,
  MARKET_SPREADS,
  MARKET_TOTALS,
  MORE_WAGERS_FIRST_HALF,
  WAGERS_PLAYER_PROPS,
} from 'consts/app';
import { BetDetailModel, ShareBetDetailModel } from 'models';

const formatPrice = (price: number, fixed: number): number | string => {
  return `${price > 0 ? '+' : ''}${new BigNumber(price).toFixed(fixed)}`;
};

const checkPlayerPropsBet = (market: string): boolean => {
  return WAGERS_PLAYER_PROPS.includes(market);
};

const getMarketName = (
  market: string,
):
  | 'Spread'
  | 'Moneyline'
  | 'Total point'
  | 'First half spread'
  | 'First half money'
  | 'First half total' => {
  if (MORE_WAGERS_FIRST_HALF[0].markets.includes(market)) return 'First half spread';
  if (MORE_WAGERS_FIRST_HALF[1].markets.includes(market)) return 'First half money';
  if (MORE_WAGERS_FIRST_HALF[2].markets.includes(market)) return 'First half total';
  if (MARKET_SPREADS.includes(market)) return 'Spread';
  if (MARKET_MONEYLINES.includes(market)) return 'Moneyline';
  return 'Total point';
};

const getMarketValue = (
  market: string,
  converter: string,
  price: number,
  decimalPrice: number,
  point: number,
  m: string,
): string | number => {
  if (MARKET_MONEYLINES.includes(market) || MORE_WAGERS_FIRST_HALF[1].markets.includes(market)) {
    return converter === 'decimal' ? formatPrice(decimalPrice, 2) : formatPrice(price, 0);
  } else if (MARKET_SPREADS.includes(market) || MORE_WAGERS_FIRST_HALF[0].markets.includes(market))
    return formatPrice(point, 2);
  else if (
    MARKET_TOTALS.includes(market) ||
    MORE_WAGERS_FIRST_HALF[2].markets.includes(market) ||
    WAGERS_PLAYER_PROPS.includes(market)
  ) {
    if (m === 'over') return `O ${point}`;
    else return `U ${point}`;
  }
  return 0;
};

const getTeaserPoint = (
  bet: BetDetailModel | undefined | ShareBetDetailModel,
  levelPoint: number,
): string => {
  if (bet?.market.market === 'point_spread') {
    const betPoint = bet.market.betPoints as number;
    const result = betPoint + levelPoint;
    return result.toString();
  }
  if (bet?.market.market === 'total_points') {
    const betPoint = bet.market.betPoints as number;
    const result =
      bet.market.selectionLine === 'under' ? betPoint + levelPoint : betPoint - levelPoint;
    return result.toString();
  }
  return '0';
};

export { formatPrice, getMarketValue, getMarketName, getTeaserPoint, checkPlayerPropsBet };
